<template>
  <div class="accountSettings">
    <div class="accountSettings_head">
      <div class="accountSettings_head-title">Fleet Care settings</div>
      <custom-btn
          v-if="isEdit"
          text="Edit"
          width="70px"
          custom-class="apply"
          @updateEvent="onEdit(true, 'isAccountSettingDrawer')"
      ></custom-btn>
    </div>
    <div class="accountSettings_body" v-if="accountSettings">
      <div class="accountSettings_body-title">Phisical address</div>
      <field
          margin="10px 0 10px 0"
          width="390px"
          label="Street, building"
          :setInputValue="physical_address_street.setting_value"
          is-readonly
      ></field>
      <field
          margin="0 0 10px 0"
          width="390px"
          label="City, State, ZIP"
          :setInputValue="physical_address_city.setting_value"
          is-readonly
      ></field>
      <field
          margin="0 0 10px 0"
          width="390px"
          label="Phone"
          :setInputValue="phone.setting_value"
          is-readonly
      ></field>

      <field
          margin="0 0 10px 0"
          width="390px"
          label="Identification number"
          :setInputValue="identification_number.setting_value"
          is-readonly
      ></field>
      <field
          margin="0 0 10px 0"
          width="390px"
          label="Ein"
          :setInputValue="ein.setting_value"
          is-readonly
      ></field>
      <account-list
          :list="zelleAccountDefault"
          hide-btn
      ></account-list>
      <div class="accountSettings_body-title">Services</div>
      <field
          v-for="{ id, name } in accountServices"
          :key="id"
          margin="10px 0 10px 0"
          width="390px"
          :setInputValue="name"
          is-readonly
      ></field>
    </div>
    <account-settings-drawer
        v-if="isAccountSettingDrawer"
        :isCreate="isCreate"
        :isDelete="isDelete"
        @closeDrawer="onEdit(false, 'isAccountSettingDrawer')"
        @updateSettings="onSettingsSave"
        @updateAccountEdit="onAccountEdit"
    ></account-settings-drawer>
    <account-list-drawer
        v-if="isAccountListDrawer"
        :accountItem="accountItem"
        @closeDrawer="onEdit(false, 'isAccountListDrawer')"
        @updateAccountList="onAccountListSave"
    ></account-list-drawer>
    <preload v-if="preloader"></preload>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// shared
import Preload from "@/shared/Preload/Preload";
// components
import AccountList from "@/components/Settings/AccountingSettings/AccountList/AccountList.vue";
import AccountListDrawer from "@/components/Settings/AccountListDrawer/AccountListDrawer.vue";
import AccountSettingsDrawer
from "@/components/Settings/AccountingSettings/AccountSettingsDrawer/AccountSettingsDrawer.vue";
// constants
import { PERMISSIONS } from "@/constants/constants";
import getUniqId from "@/helper/getUniqId";
import { getPermissionsMod } from "@/helper/getPermissionsMod";

export default {
	name: "AccountSettings",
	components: {
		Preload,
		AccountSettingsDrawer,
		AccountListDrawer,
		AccountList,
	},
	computed: {
		...mapGetters([
			"accountServices",
			"accountSettings",
			'zelleAccount',
			'zelleAccountDefault',
			'permissionsDefault',
		]),
		isEdit() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.SETTINGS, PERMISSIONS.ACCOUNT_SETTINGS, PERMISSIONS.EDIT ];
			return getPermissionsMod({ list, path });
		},
		isCreate() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.SETTINGS, PERMISSIONS.ACCOUNT_SETTINGS, PERMISSIONS.CREATE ];
			return getPermissionsMod({ list, path });

		},
		isDelete() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.SETTINGS, PERMISSIONS.ACCOUNT_SETTINGS, PERMISSIONS.DELETE ];
			return getPermissionsMod({ list, path });
		}
	},
	data: () => ({
		isAccountSettingDrawer: false,
		isAccountListDrawer: false,
		preloader: false,
		physical_address_street: { setting_value: "" },
		physical_address_city: { setting_value: "" },
		phone: { setting_value: "" },
		zelle_account: { setting_value: "" },
		account_number: { setting_value: "" },
		identification_number: { setting_value: "" },
		ein: { setting_value: "" },
		direct_deposit_routing: { setting_value: "" },
		transfer_routing: { setting_value: "" },
		accountItem: null
	}),
	methods: {
		...mapActions([ 'getAccountSettings', 'onAccountSettingsSave', 'onDefaultList', 'setAlert' ]),
		onEdit(value, key) {
			this[key] = value;
			this.onDefaultList();
		},
		onAccountListSave(values) {
			const idxById = this.zelleAccount.findIndex(item => item.id === values.id);
			if (idxById !== -1) {
				this.zelleAccount.splice(idxById, 1, values);
			} else {
				values.id = getUniqId();
				this.zelleAccount.push(values);
			}
			this.isAccountListDrawer = false;
		},
		async onSettingsSave(values) {
			const { status } = await this.onAccountSettingsSave(values);
			if (status) {
				this.isAccountSettingDrawer = false;
				this.accountSettings.forEach((item) => (this.$data[item.setting_key] = item));
				this.setAlert({ type: "success", message: "Data saved successfully" });
			}
		},
		async init(isRequest) {
			if (isRequest) await this.getAccountSettings();
			this.accountSettings.forEach((item) => (this.$data[item.setting_key] = item));
		},
		onAccountEdit(values) {
			this.accountItem = values;
			this.isAccountListDrawer = true;
		}
	},
	async mounted() {
		await this.init(1);
	},
};
</script>

<style scoped lang="scss">
@import "accountSettings";
</style>
